import { getRegister } from "../../utils/helpers";
import { URL_ROLES } from "../../utils/urls";
import { PermissionsSection } from "../../components/pages/permissions/PermissionsSection";

export const useRolesForm = ({ form, updateFormValue, id }) => {
  const isUpdate = id ? true : false;

  const sections: any = [
    {
      title: "Role Details",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Role Name",
          props: {
            required: true,
            disabled: isUpdate,
          },
        },
      ],
    },
    {
      title: "Role Permissions",
      component: (
        <PermissionsSection
          role_permissions={form?.permissions}
          updateFormValue={updateFormValue}
        />
      ),
    },
  ];

  const redirect = getRegister(URL_ROLES);

  return { sections, redirect };
};
